export const PROJECT_FINANCIAL_DETAILS_COMMENT_MAX_LENGTH = 2000;
